import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Helper } from 'src/app/shared/helper';
import { TOAST_STATE } from '../constant/constant';
import { ToastService } from "src/app/data/services/toastr.service";

@Injectable()
export class ResInterceptor implements HttpInterceptor {
  constructor(private helper: Helper, private toasterService: ToastService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { isShowSuccessToast, isShowErrorToast } = this.isShowToast(req);

    return next.handle(req).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse && evt.body) {
          // ✅ Clear "Too Many Requests" flag on successful response
          sessionStorage.removeItem('tooManyRequests');

          this.helper.showBtnLoader = [];

          const hasBodySuccessKey = evt.body.success !== undefined;
          const isBodySuccessFalse = hasBodySuccessKey && !evt.body.success;
          const hasErrorMessage = !!evt.body.message;

          if ((evt.status === 200 || evt.status === 201) && req.body && isShowSuccessToast && hasErrorMessage) {
            if (isBodySuccessFalse && evt.body.message) {
              this.toasterService.showToast(
                TOAST_STATE.danger,
                this.helper.trans.instant(evt.body.message)
              );
              return;
            }

            const successMessage = this.helper.trans.instant(evt.body.message);
            this.toasterService.showToast(
              TOAST_STATE.success, successMessage
            );
          } else if (hasErrorMessage && isBodySuccessFalse && isShowErrorToast !== false) {
            const errorMessage = this.helper.trans.instant(evt.body.message);
            this.toasterService.showToast(
              TOAST_STATE.danger,
              errorMessage
            );
          }
        }
      }),
      catchError((err: any) => {
        this.helper.showBtnLoader = [];

        if (err instanceof HttpErrorResponse && err.status !== 200) {

          // Handle 429 Too Many Requests
          if (err.status === 429) {
            sessionStorage.setItem('tooManyRequests', 'true'); // Store the flag
            this.helper._route.navigate(['/too-many-requests']);
          }

          if (err.status === 409 || err.error.message === "Error decrypting token") {
            localStorage.removeItem("userToken");
            this.helper._route.navigate(["/"]).then(() => {
              window.location.reload();
            });
          }

          if (isShowErrorToast !== false) {
            const errorMessage = err.error.message ?? err.message;
            this.toasterService.showToast(
              TOAST_STATE.danger,
              errorMessage
            );
          }
        }

        throw err;
      })
    );
  }

  isShowToast(req: HttpRequest<any>): { isShowSuccessToast: boolean; isShowErrorToast: boolean } {
    let isShowSuccessToast = true;
    let isShowErrorToast = true;

    if (req.body && req.body instanceof FormData) {
      ({ isShowSuccessToast, isShowErrorToast } = this.checkToastFlags(req.body, isShowSuccessToast, isShowErrorToast));
    } else {
      if (req.body) {
        if (req.body.isShowSuccessToast === false) {
          isShowSuccessToast = false;
        }
        if (req.body.isShowErrorToast === false) {
          isShowErrorToast = false;
        }
      }
      ({ isShowSuccessToast, isShowErrorToast } = this.checkToastFlags(req.params, isShowSuccessToast, isShowErrorToast));
    }

    return { isShowSuccessToast, isShowErrorToast };
  }

  checkToastFlags(data: any, isShowSuccessToast: boolean, isShowErrorToast: boolean): { isShowSuccessToast: boolean; isShowErrorToast: boolean } {
    if (data) {
      if (data.has("isShowSuccessToast") && data.get("isShowSuccessToast") === "false") {
        isShowSuccessToast = false;
      }
      if (data.has("isShowErrorToast") && data.get("isShowErrorToast") === "false") {
        isShowErrorToast = false;
      }
    }

    return { isShowSuccessToast, isShowErrorToast };
  }
}

